// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"0281660c","453":"847702cc"}[chunkId] + ".chunk.js";
};